import { useCallback, useState } from 'react';
import memoizeOne from 'react-utils/memoizeOne';
import CALENDAR_VIEW_TYPES from '../constants/CalendarViewTypes';
import { getClosestSnapPoint, getEventDurationInHours } from '../lib/dragDrop';
import { useTheme } from '../lib/styles';
export const SNAP_INTERVAL_MILLIS = 60 * 60 * 1000;
const isSameDay = (a, b) => a.isSame(b, 'day');
const getMomentStartOfTheDay = memoizeOne(droppedMoment => droppedMoment.clone().startOf('day'), isSameDay);
export default function useSetIsSameTimeForViewType({
  containerRef,
  viewType
}) {
  const {
    uiAddonCalendars: {
      dayView: {
        hourHeight
      },
      util: {
        raw
      }
    }
  } = useTheme();
  const [state, setState] = useState(false);
  const rawHourHeight = raw(hourHeight);
  const setIsSameTimeForViewType = useCallback(({
    droppedMoment
  }, monitor) => {
    let isSameTime = false;
    const item = monitor.getItem();
    const {
      start,
      end
    } = item._internal ? item._internal : item;
    if (droppedMoment && start) {
      if (viewType === CALENDAR_VIEW_TYPES.MONTH) {
        isSameTime = droppedMoment.isSame(start, 'day');
      } else {
        const eventDurationInHours = getEventDurationInHours(start, end);
        const closestSnapPoint = getClosestSnapPoint({
          containerRef,
          monitor,
          eventDurationInHours,
          hourHeight: rawHourHeight
        });
        const startOfTheDayMillis = getMomentStartOfTheDay(droppedMoment).valueOf();
        const lowerSnapPointMillis = startOfTheDayMillis + closestSnapPoint * SNAP_INTERVAL_MILLIS;
        const upperSnapPointMillis = lowerSnapPointMillis + SNAP_INTERVAL_MILLIS;
        isSameTime = lowerSnapPointMillis <= start && start < upperSnapPointMillis;
      }
    }
    setState(isSameTime);
  }, [viewType, containerRef, rawHourHeight, setState]);
  return [state, setIsSameTimeForViewType];
}